import dynamic from "next/dynamic";
import Payment from "@/Components/pages/success-payment";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { GetServerSideProps, NextPage } from "next";

const HocHead = dynamic(
  () => import("@/Components/HigherOrderComponent/HocHead"),
);

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { query } = ctx;

  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59",
    );
  }

  const isEmpty = (query: any) => Object.keys(query).length === 0;

  if (isEmpty(query)) {
    return { redirect: { permanent: false, destination: "/" } };
  }

  const res = await fetch(`${baseUrl}paypal/handle-payment`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(query),
  });

  if (res.ok !== true || res.status !== 200) {
    const error = await res.json();

    return {
      props: {
        data: null,
        query: null,
        error: error?.error?.message ?? null,
      },
    };
  }

  const data = await res.json();

  return {
    props: {
      data,
      query,
      error: null,
    },
  };
};

interface Props {
  data: any;
  query: any;
  error: any;
}
const SuccessPayment: NextPage<Props> = ({ data, query, error }) => {
  const router = useRouter();

  useEffect(() => {
    // Remove query parameters from the URL
    const { pathname } = router;
    router.push(pathname, undefined, { shallow: true });
  }, [router]);

  return (
    <>
      <HocHead />
      <div className="middle-sction middle-pad">
        <Payment data={data} query={query} error={error} />
      </div>
    </>
  );
};

export default SuccessPayment;
